<template>
  <div class="px-4">
    <div class="flex justify-between h-16">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center space-x-6 shrink-0">
          <a href="https://pastaevangelists.com/" aria-label="Go to homepage">
            <ThePastaLogo class="h-auto py-4 cursor-pointer w-[100px] text-terracota-dark" />
          </a>
        </div>
        <div class="hidden space-x-1 lg:flex">
          <CardIcon class="w-10" brand="mastercard" />
          <CardIcon class="w-10" brand="visa" />
          <CardIcon class="w-10" brand="amex" />
          <template v-if="!hideThirdPartyPayments">
            <CardIcon class="w-10" brand="google_pay" />
            <CardIcon class="w-10" brand="apple_pay" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import ThePastaLogo from '@/components/ThePastaLogo.vue';

  interface Props {
    hideThirdPartyPayments?: boolean;
  }

  defineProps<Props>();
</script>
